module.exports = {
  reCaptchaKey: process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
  scriptProps: {
    async: true
  }
};
